const initialState = {
    student:null,
    teacher:null,
    schoolAdmin:null,
    chartData:null,
    chartRules:{
        growthRate:[1.1,1.1,1.15,1.15,1.25,1.25,1.25,1.25],
        maxLevel:12,
        showScore:false,
        isTeacher:true
    },
    xLabel:"Weeks",
    yLabel:"Levels",
    updateNote:null,
    lastClass:null,
    lastTeacher:null,
    lastSchool:null,
    studentTab:1,
    studentScoreListTab:0,
    appName:""
};

export default function(state = initialState, action) {
    switch (action.type) {
        case "UPDATE_STUDENT":
            return { ...state, student: action.student };
        case "UPDATE_TEACHER":
            return { ...state, teacher: action.teacher };
        case "UPDATE_SCHOOL_ADMIN":
            return { ...state, schoolAdmin: action.schoolAdmin};
        case "UPDATE_CHART_DATA":
            return { ...state, chartData: action.chartData, chartRules: action.chartRules, xLabel:action.xLabel, yLabel: action.yLabel };
        case "UPDATE_FUNCTION_UPDATE_NOTE":
            return { ...state, updateNote: action.updateNote };
        case "UPDATE_APPNAME":
            return { ...state, appName: action.appName };
        case "SELECT_CLASS":
            return { ...state, lastClass: action.lastClass };
        case "SELECT_TEACHER":
            return { ...state, lastTeacher: action.lastTeacher };
        case "SELECT_SCHOOL":
            return { ...state, lastSchool: action.lastSchool };
        case "SELECT_STUDENT_TAB":
            return { ...state, studentTab: action.studentTab };
        case "SELECT_SCORELIST_TAB":
            return { ...state, studentScoreListTab: action.studentScoreListTab };
        case "LOGOUT":
            return {...state,...initialState};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/TeachersComponent/reducers.js